import styled from 'styled-components';

import { UiTypography } from '@/components/ui/Typography';

export const Card = styled.div`
  background: linear-gradient(96.09deg, #fe541b 0%, #fe1b39 100%);
  color: white;
  width: 100%;
  margin: 20px auto 27px;
  padding: 16px;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
  align-self: center;
  position: relative;
  overflow: hidden;

  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: url('/assets/paywall/fast-pay-tab-man/promo-code-background.png')
      no-repeat center / cover;
    border-radius: 12px;
    z-index: 0;
    opacity: 0.5;
    pointer-events: none;
  }
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`;

export const Divider = styled.div`
  width: 100%;
  height: 1px;
  background: #d90e17;
  margin: 10px 0;
`;

export const Footer = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
`;

export const PromoCodeContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  background: #b0151b;
  padding: 8px 12px;
  border-radius: 12px;
  margin-top: 8px;
  z-index: 1;
  width: 70%;
`;

export const PromoCodeIcon = styled.div`
  width: 16px;
  height: 16px;
  border-radius: 50%;
  overflow: hidden;
  margin-right: 8px;
  background: url('/assets/icons/PercentageIcon.png') no-repeat center / contain;
`;

export const PromoCodeText = styled(UiTypography).attrs({
  variant: 'body-medium',
})`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const DiscountText = styled.span`
  font-weight: 700;
  font-size: 24px;
  line-height: 32px;
  letter-spacing: 0.15px;
  margin-top: 6px;
  white-space: nowrap;
`;
